import { render, staticRenderFns } from "./DocumentApprovalTab.vue?vue&type=template&id=6c228777&scoped=true"
import script from "./DocumentApprovalTab.vue?vue&type=script&lang=js"
export * from "./DocumentApprovalTab.vue?vue&type=script&lang=js"
import style0 from "./DocumentApprovalTab.vue?vue&type=style&index=0&id=6c228777&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c228777",
  null
  
)

export default component.exports